import type { ListItemProps } from './ListItem';

export type OldListItemProps<T extends string = string> = Omit<
  ListItemProps<T>,
  'label' | 'checked' | 'onCheckedChange'
> & {
  /** @deprecated label을 대신 사용해주세요. */
  text: ListItemProps<T>['label'];
  /** @deprecated checked를 대신 사용해주세요. */
  isOn?: ListItemProps<T>['checked'];
  /** @deprecated onCheckedChange를 대신 사용해주세요. */
  onToggle?: ListItemProps<T>['onCheckedChange'];
};

export function convertOldListItemProps<T extends string>(props: OldListItemProps<T>): ListItemProps<T> {
  const { text, isOn, onToggle, ...restProps } = props;

  return {
    ...restProps,
    label: text,
    checked: isOn,
    onCheckedChange: onToggle,
  };
}

export function convertNewListItemPropsToOld<T extends string>(props: ListItemProps<T>): OldListItemProps<T> {
  const { label, checked, onCheckedChange, ...restProps } = props;

  return {
    ...restProps,
    text: label,
    isOn: checked,
    onToggle: onCheckedChange,
  };
}
